import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { AuthGuard } from '../../auth/auth.guard';

@Component({
  selector: 'vr-toolbar-user-button',
  templateUrl: './toolbar-user-button.component.html',
  styleUrls: ['./toolbar-user-button.component.scss']
})
export class ToolbarUserButtonComponent implements OnInit, AfterViewInit {

  user;
  isOpen: boolean;

  constructor(
    private router: Router,
    public authGuard: AuthGuard,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.user = this.authGuard.session;
  }

  ngAfterViewInit() {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

  profile() {
    this.isOpen = false;
    this.router.navigate(['/profile']);
  }

  logout() {
    this.isOpen = false;
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/toolbar/toolbar-user-button/toolbar-user-button.component.ts